export enum PaymentAccountTabLabel {
  ACCOUNTS_PAYABLE = "ACCOUNTS PAYABLE",
  ACCOUNTS_RECEIVABLE = "ACCOUNTS RECEIVABLE",
}
